import fetchAPI from '../fetchAPI';
import { useQuery } from '@tanstack/react-query';

type BroadcastEventsProps = {
  startDate?: string | null;
  endDate?: string | null;
  type: string;
  locationId?: string;
};

export const useBroadcastEvents = ({ locationId, endDate, startDate, type }: BroadcastEventsProps) => {
  const query = new URLSearchParams();

  if (locationId) query.append('locationId', locationId);
  if (endDate) query.append('endDate', endDate);
  if (startDate) query.append('startDate', startDate);
  
  return useQuery({
    queryKey: ['/broadcast-event', locationId, type, startDate, endDate],
    queryFn: async () => {
      const response: iResponse<{ total: number, sms: Record<string, number>, whatsapp: Record<string, number> }> = await fetchAPI({
        method: 'GET',
        route: `broadcast-event/${type}`,
        queryString: query.toString()
      });

      return response;
    },
    enabled: !!startDate && !!endDate // Query will only run if type is provided
  });
};

export default useBroadcastEvents;
